export * from './types';
export * from './BaseProvider';
export * from './SelfHostedProvider';
export * from './OllamaProvider';
export * from './OpenAICompatibleProvider';
export * from './GroqProvider';
export * from './OpenRouterProvider';

import { AIProvider, ProviderType, ProviderConfig } from './types';
import { SelfHostedProvider } from './SelfHostedProvider';
import { OllamaProvider } from './OllamaProvider';
import { OpenAICompatibleProvider } from './OpenAICompatibleProvider';
import { GroqProvider } from './GroqProvider';
import { OpenRouterProvider } from './OpenRouterProvider';
import { OnnxProvider } from './OnnxProvider';

const providerInstances: Map<ProviderType, AIProvider> = new Map();

export function getProvider(type: ProviderType): AIProvider {
  let provider = providerInstances.get(type);

  if (!provider) {
    switch (type) {
      case 'selfhosted':
        provider = new SelfHostedProvider();
        break;
      case 'ollama':
        provider = new OllamaProvider();
        break;
      case 'lmstudio':
        provider = new OpenAICompatibleProvider();
        break;
      case 'groq':
        provider = new GroqProvider();
        break;
      case 'openrouter':
        provider = new OpenRouterProvider();
        break;
      case 'onnx':
        provider = new OnnxProvider();
        break;
      default:
        throw new Error(`Unknown provider type: ${type}`);
    }
    providerInstances.set(type, provider);
  }

  return provider;
}

export function configureProvider(config: ProviderConfig): AIProvider {
  const provider = getProvider(config.type);
  provider.configure(config);
  return provider;
}

export function getAllProviders(): AIProvider[] {
  const types: ProviderType[] = ['selfhosted', 'ollama', 'lmstudio', 'groq', 'openrouter'];
  return types.map(type => getProvider(type));
}
